import React from 'react';

export default function CompliancePageHeader({ title, subtitle, action }) {
  return (
    <div className="compliance-dashboard-top">
      <div className="page-header page-header--compliance">
        <div className="page-header-left">
          <h1 className="page-title">{title}</h1>
          {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
        </div>
        {action ? <div className="page-header-action">{action}</div> : null}
      </div>
    </div>
  );
}
